import VueCookies from 'vue-cookies'
import { setContext } from '@apollo/client/link/context';
import { useLocaleStore } from '@/composables/useLocaleStore'
import i18n from '@/i18n/admin'
import { isPublicRoute, resolvePublicLocale } from '@/composables/usePublicLocale'

export function useApolloAuth(router = null) {

    const authContext     = setContext((_, { headers }) => {

        const token = VueCookies.get('admin_token')

        const localeStore       = useLocaleStore()
        const publicRoute = isPublicRoute(router?.currentRoute?.value)

        if(!token && !publicRoute){
            console.warn("Auth token is empty")
        }

        const uiLocale = i18n.global.locale
        const selectedLanguage = publicRoute
            ? resolvePublicLocale()
            : ((typeof uiLocale === 'string' ? uiLocale : uiLocale?.value)
                || localeStore.getSelectedLanguage()
                || 'en')

        const authHeaders = {
            headers: {
                ...headers,
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                'X-Locale'          : selectedLanguage,
                'X-Locale2'          : selectedLanguage,
                'Accept-Language'   : selectedLanguage,
            }
        }

        return authHeaders
    })

    return {
        authContext
    }
}
